import { render, staticRenderFns } from "./DetailAssesment.vue?vue&type=template&id=8bb220c8&"
import script from "./DetailAssesment.vue?vue&type=script&lang=js&"
export * from "./DetailAssesment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports